import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SOCIAL_STARTER_POST_CREATE_ONBOARDING = defineFcm('social_starter_post_create_onboarding')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'social_starter_post_create_onboarding',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context: 'Post-Start A Petition Social Starter Onboarding',
		description:
			'Controls whether petitions originating from the social starters flow see an additional onboarding step between sharing personally and sharing socially.',
		template: {
			experimentName: 'social_starter_post_create_onboarding',
			enabled: false,
		},
	});
